import { mapState } from 'vuex'
import { getUser, logout, switchLogin } from '@/api/user'
import dstrMenu from '@/menu/dstr'
import chanMenu from '@/menu/chan'
import Tab from './tab/Tab.vue';
import PasswordForm from '@/components/layout/password/Password.vue'
import BuildForm from '@/components/layout/build-form/BuildForm.vue'
import watermark from 'watermark-dom'


export default {
    components: {
        Tab,
        PasswordForm,
        BuildForm,
    },
    data() {
        return {
            collapsed: false,
            routeName: this.$route.name,
            loading: false,
            showPasswordForm: false,
            showBuildForm: false,
            passwordModel: {},
            rootKeys: [],
            childKeys: {},
            openKeys: [],
            menus: [],
            platform: localStorage.getItem('platform'),
            accounts: [],
        }
    },
    computed: {
        ...mapState({
            admin: state => state.stores.admin
        }),
        currentMenu() {
            return this.getCurrentMenu()
        },
        windowWidth(){
			const { windowWidth } = this.$store.state.tabStore;
			return windowWidth;
		},
		phone(){
			return this.windowWidth<992;
		}
    },
    watch:{
		windowWidth(){
			this.resize();
		}
	},
    activated(){
        this.getCurrentAdmin()
        this.resize();
    },
    deactivated(){
        this.getCurrentAdmin()
    },
    created() {
        this.getCurrentAdmin(true)
        this.resize();
    },
    methods: {
        resize(){
			if(this.windowWidth<992){
				this.collapsed = true;
			}else{
				this.collapsed = false;
			}
		},
        getCurrentAdmin(init) {
            if (this.$store.state.stores.admin) {
                this.passwordModel.id = this.$store.state.stores.admin.id
                if(init){
                    this.setRootKeys()
                }
                this.openKeys = this.currentMenu.pids
                return
            }
            getUser().then(res => {
                watermark.load({
                    watermark_txt: `${res.data.name} ${res.data.username || ''}`,
                    watermark_alpha: 0.08,
                    watermark_width: 150,
                    watermark_angle: 8
                })
                switch (this.platform) {
                    case 'dstr':
                        res.data.menu = dstrMenu
                        break
                    case 'chan':
                        res.data.menu = chanMenu
                        break
                }
                localStorage.setItem('name', res.data.name)
                if (this.platform !== 'sys' && document.title.split('-').length < 3) {
                    document.title = `${res.data.name}-${document.title}`
                }
                this.$store.commit('setAdmin', res.data)
                this.passwordModel.id = this.$store.state.stores.admin.id
                this.setRootKeys()
                this.openKeys = this.currentMenu.pids
            }).catch(() => {})
        },
        getCurrentMenu() {
            if (!this.admin) {
                return {
                    menu: { id: 0 },
                    parent: { id: 0 },
                    pids: []
                }
            }
            for (let key in this.admin.menu) {
                const menu = this.admin.menu[key]
                if (menu.url === this.routeName) {
                    return {
                        menu: menu,
                        parent: { id: 0 },
                        pids: []
                    }
                }
                for (let subKey in menu.children) {
                    const subMenu = menu.children[subKey]
                    if (subMenu.url === this.routeName) {
                        return {
                            menu: subMenu,
                            parent: menu,
                            pids: [menu.id]
                        }
                    }
                    for (let grandKey in subMenu.children) {
                        const grandMenu = subMenu.children[grandKey]
                        if (grandMenu.url === this.routeName) {
                            return {
                                menu: grandMenu,
                                parent: subMenu,
                                pids: [subMenu.id, menu.id]
                            }
                        }
                    }
                }
            }
            return {
                menu: { id: 0 },
                parent: { id: 0 },
                pids: []
            }
        },
        clickChange(e){
            const pathKey = e.key;
            const lastSelectKeyPath = e.keyPath.filter(key=>key!=pathKey);
            this.openKeys = lastSelectKeyPath;
        },
        onOpenChange(openKeys) {
            const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
            if (this.rootKeys.indexOf(latestOpenKey) === -1) {
                this.openKeys = openKeys
            } else {
                this.openKeys = latestOpenKey ? [latestOpenKey] : []
            }
            let arrs = []
            for (let childKey in this.childKeys) {
                childKey = parseInt(childKey)
                if (latestOpenKey !== childKey) {
                    arrs.push(childKey)
                }
            }
            this.openKeys = this.openKeys.filter(item => {
                return !arrs.includes(item)
            })
        },
        goPage (name) {
            if (!name || name === this.$route.name) {
                return
            }
            let totalRoutes = []
            this.$router.getRoutes().map(route => {
                totalRoutes.push(route.name)
            })
            if (!totalRoutes.includes(name)) {
                return this.$router.push('/404')
            }
            this.$router.push({ name: name })
        },
        setRootKeys () {
            if (!this.$store.state.stores.admin) {
                return false
            }
            const menus = this.$store.state.stores.admin.menu
            for (const key in menus) {
                const menu = menus[key]
                this.rootKeys.push(menu.id)
                if (!menu.children) {
                    continue
                }
                for (const subKey in menu.children) {
                    const sub = menu.children[subKey]
                    if (sub.children) {
                        this.childKeys[sub.id] = menu.id
                    }
                }
            }
        },
        logout() {
            const vue = this
            this.$confirm({
                title: '操作提示',
                centered: true,
                content: () => '确定要退出系统吗？',
                onOk() {
                    vue.loading = true
                    logout().then(() => {
                        vue.$store.commit("resetOpenTab");
                        localStorage.removeItem('token')
                        vue.$router.push({
                            name: 'login',
                            params: {
                                'platform': vue.platform
                            }
                        })
                    }).finally(() => {
                        vue.loading = false
                    })
                }
            });
        },
        updatePassword() {
            this.showPasswordForm = true
        },
        refresh() {
            this.showPasswordForm = false
        },
        build() {
            this.showBuildForm = true
        },
        switchAccount(item) {
            this.loading = true
            switchLogin({dingtalk_id:item.dingtalk_id}).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('切换成功')

                    setTimeout(() => {
                        window.location.reload()
                    }, 300)
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
